module.exports = __webpack_public_path__ + "media/empty-states/referrals-2x-33583fcc.png";